<template>
  <div
    v-if="missingRequiredProfileInformation"
    class="px-8 pt-6 pb-2 bg-grey-light rounded mb-8 shadow"
  >
    <h3
      class="font-bold text-base mt-0 mb-4 bg-blue text-white -mt-6 -mx-8 pt-6 px-8 pb-2 rounded-t border-b-4 border-yellow pb-4"
      v-text="'Additional Profile Information Required!'"
    />
    <div
      class="text-sm mb-6"
      v-text="'In the near future NEP Connect will be removing the ability to log in with email/password and you will log in using a code sent via text message to your mobile phone instead.'"
    />
    <ProfilePhoneNumberField
      v-model="phoneNumber"
      :errors="errors"
    />
    <SecurityQuestionField
      v-if="!hasAnsweredSecurityQuestion"
      v-model="securityQuestion"
      label-classes="block text-xs mb-2"
      label="Choose a Security Question"
      :error-message="errors.get('security_question')"
      :questions="securityQuestions.map(option => option.question)"
    />
    <div v-if="!hasAnsweredSecurityQuestion">
      <label
        class="block text-xs mb-2"
        for="security-question-answer"
        v-text="'Provide an Answer (case-sensitive)'"
      />
      <input
        id="security-question-answer"
        v-model="securityAnswer"
        name="security-question-answer"
        :class="{ 'error': errors.has('security_answer') }"
        type="text"
      >
      <span
        v-if="errors.has('security_answer')"
        class="help-block mb-1"
        v-text="errors.get('security_answer')"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import SecurityQuestionField from 'Auth/Resources/assets/js/components/sms/SecurityQuestionField'
import ProfilePhoneNumberField from './ProfilePhoneNumberField'

export default {
  name: 'MissingProfileInformation',
  components: {
    ProfilePhoneNumberField,
    SecurityQuestionField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    securityQuestions: {
      type: Array,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    hasAnsweredSecurityQuestion: {
      type: Boolean,
      required: true,
    },
    hasValidPhoneNumber: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    phoneNumber: {
      get() {
        return {
          phone_number: this.value.phone_number,
          phone_number_country: this.value.phone_number_country,
        }
      },
      set(value) {
        this.emit({
          phone_number: value.phone_number,
          phone_number_country: value.phone_number_country,
        })
      },
    },
    securityQuestion: {
      get() {
        return this.value.security_question
      },
      set(value) {
        this.emit({ security_question: value })
      },
    },
    securityAnswer: {
      get() {
        return this.value.security_answer
      },
      set(value) {
        this.emit({ security_answer: value })
      },
    },
    missingRequiredProfileInformation() {
      return !this.hasValidPhoneNumber || !this.hasAnsweredSecurityQuestion
    },
  },
  methods: {
    emit(data) {
      this.$emit('input', {
        ...{
          phone_number: this.value.phone_number,
          phone_number_country: this.value.phone_number_country,
          security_question: this.value.security_question,
          security_answer: this.value.security_answer,
        },
        ...data,
      })
    },
    async handlePhoneUpdate(data) {
      await this.$nextTick()

      this.emit({ phone_number_country: data.countryCode })
    },
  },
}
</script>
